<template>
  <div class="smc-border">
    <SummarizationCard title='Reason for Insurance'>
      <SummarizationItem>
        <template v-slot:title>
          Selected Reason for Insurance
        </template>
        <p class="m-0">
          {{ person.insuredPersonType ? person.insuredPersonType.label : '' }}
        </p>
      </SummarizationItem>
      <SummarizationItem v-if="isChangeOfInsuranceCompany">
        <template v-slot:title>
          Current Health Insurance Provider
        </template>
        <p class="m-0">
          {{ person.previousInsuranceCompany.label }}
        </p>
      </SummarizationItem>
    </SummarizationCard>

    <SummarizationCard title='Personal Data'>
      <SummarizationItem>
        <template v-slot:title>
          Name and Surname
        </template>
        <p class="m-0">
          {{ person.name + ' ' + person.surname }}
        </p>
      </SummarizationItem>
      <SummarizationItem>
        <template v-slot:title>
          Birth Name
        </template>
        <p class="m-0">
          {{ person.birthSurname }}
        </p>
      </SummarizationItem>
      <SummarizationItem>
        <template v-slot:title>
          Nationality
        </template>
        <p class="m-0">
          {{ person.nationality.label }}
        </p>
      </SummarizationItem>
    </SummarizationCard>

    <SummarizationCard title='Identity Verification'>
      <SummarizationItem>
        <template v-if="person.hasBirthNumber" v-slot:title>
          Birth Number
        </template>
        <template v-else v-slot:title>
          BIČ
        </template>
        <p class="m-0">
          {{ person.birthNumber }}
        </p>
      </SummarizationItem>
      <SummarizationItem>
        <template v-slot:title v-if="isID" >ID Card Number</template>
        <template v-slot:title v-else-if="isPassport" >Passport Number</template>
        <template v-slot:title v-else-if="isResidencePermit" >Permit Number</template>
        <template v-slot:title v-else-if="isZiadost" >Application Number</template>
        <p class="m-0">
          {{ person.evidenceNumber }}
        </p>
      </SummarizationItem>
      <SummarizationItem>
        <template v-if="isID || isPassport || isResidencePermit" v-slot:title>
          Date Issued
        </template>
        <template v-else v-slot:title>
          Date of Application
        </template>
        <p v-if="person.validityOfDocumentFrom" class="m-0">
          {{ formatDate(person.validityOfDocumentFrom) }}
        </p>
        <p v-else-if="person.validityOfZiadost" class="m-0">
          {{ formatDate(person.validityOfZiadost) }}
        </p>
      </SummarizationItem>
      <SummarizationItem v-if="!isZiadost">
        <template v-if="isID || isPassport" v-slot:title>
          Date of Validity
        </template>
        <template v-else-if="isResidencePermit" v-slot:title>
          Valid Until
        </template>
        <p v-if="person.validityOfDocumentTo" class="m-0">
          {{ formatDate(person.validityOfDocumentTo) }}
        </p>
      </SummarizationItem>
      <SummarizationItem v-if="person.evidenceType === enums.EvidenceTypeEnum.RESIDENCE_PERMIT">
        <template v-slot:title>
          Validity of Stay Until
        </template>
        <p class="m-0">
          {{ formatDate(person.validityOfPermanentResidence) }}
        </p>
      </SummarizationItem>
    </SummarizationCard>

    <SummarizationCard title='Current Source of Income'>
      <SummarizationItem>
        <template v-slot:title>
          Selected Source of Income
        </template>
        <div>
          <div v-if="person.income.otherIncome">
            <p class="m-0">
              Other Source of Income
            </p>
            <p v-if="person.lifeSituation.careForChild" class="m-0">
              Caregiver for a Child
            </p>
            <p v-if="person.lifeSituation.student" class="m-0">
              Student
            </p>
            <p v-if="person.lifeSituation.takesCare" class="m-0">
              Caregiver for Another Person
            </p>
            <p v-if="person.lifeSituation.retirement" class="m-0">
              Receiving a Pension
            </p>
            <p v-if="person.lifeSituation.noRetirementClaim" class="m-0">
              No Entitlement to a Pension
            </p>
            <p v-if="person.lifeSituation.longTerm" class="m-0">
              Sickness absence / Sick leave to care for a family member
            </p>
            <p v-if="person.lifeSituation.elementaryOrHighSchoolStudent" class="m-0">
              Kindergarten or Primary School Student
            </p>
            <p v-if="person.lifeSituation.other" class="m-0">
              Other
            </p>
            <p v-if="person.lifeSituation.isInInstitutionalCare" class="m-0">
              Receiving institutional health services
            </p>
            <p v-if="person.lifeSituation.worksForChurchOrCharity" class="m-0">
              Work for a church or charity
            </p>
            <p v-if="person.lifeSituation.receiveAContributionInMaterialNeed" class="m-0">
              Receiving material need benefits 
            </p>
            <p v-if="person.lifeSituation.isPersonalAssistantForZTP" class="m-0">
              Personal Assistant for a Person with Disability (ZŤP)
            </p>
            <p v-if="person.lifeSituation.oldAgeRetirement" class="m-0">
              Retirement
            </p>
            <p v-if="person.lifeSituation.retiredRetirement" class="m-0">
              Disability
            </p>
            <p v-if="person.lifeSituation.invalidRetirement" class="m-0">
              Invalidný
            </p>
            <p v-if="person.lifeSituation.careForChildType" class="m-0">
              {{ person.lifeSituation.careForChildType.label }}
            </p>
            <p v-if="person.lifeSituation.noRetirementClaimType" class="m-0">
              {{ person.lifeSituation.noRetirementClaimType.label }}
            </p>
            <p v-if="person.lifeSituation.studentType" class="m-0">
              {{ person.lifeSituation.studentType.label }}
            </p>
            <p v-if="person.lifeSituation.takesCareType" class="m-0">
              {{ person.lifeSituation.takesCareType.label }}
            </p>
            <p v-if="person.lifeSituation.longTermType" class="m-0">
              {{ person.lifeSituation.longTermType.label }}
            </p>
          </div>
          <div v-if="person.income.isEmployee">
            <p class="m-0">
              Income from Permanent Employment
            </p>
            <p class="m-0">
              {{ person.income.employerName }}
            </p>
          </div>
          <div v-if="person.income.isSZCO">
            <p class="m-0">
              Self-Employment
            </p>
            <p class="m-0">
              {{ person.income.companyName }}
            </p>
          </div>
          <div v-if="person.income.isUnemployed">
            <p v-if="person.income.unemployedTypeEnum === unemployedTypeEnum.REGISTERED_AT_THE_LABOR_OFFICE" class="m-0">
              at the Labour Office
            </p>
            <p v-if="person.income.unemployedTypeEnum === unemployedTypeEnum.SELF_PAYER" class="m-0">
              Self-payer
            </p>
            <p v-if="person.income.receiveUnemploymentBenefit">
              Receiving Unemployment Benefits
            </p>
          </div>
        </div>
      </SummarizationItem>
    </SummarizationCard>

    <SummarizationCard title='Details of Residence'>
      <SummarizationItem>
        <template v-slot:title>
          Permanent Residence Address
        </template>
        <p class="m-0">
          {{ `${person.address.street} ${person.address.streetNumber}` }}
        </p>
        <p class="m-0">
          {{ `${person.address.zip} ${person.address.city}` }}
        </p>
        <p class="m-0">
          {{ `${person.address.country ? person.address.country.label : ''}` }}
        </p>
      </SummarizationItem>
      <SummarizationItem>
        <template v-slot:title>
          Mailing Address
        </template>
        <p v-if="person.postalAddressSameAsAddress" class="m-0">
          Same as Permanent Residence Address
        </p>
        <p v-else-if="addressNotFilled(person.postalAddress) && person.hasTemporaryResidence">
          Same as Temporary Residence Address
        </p>
        <div v-else>
          <p class="m-0">
            {{ `${person.postalAddress.street} ${person.postalAddress.streetNumber}` }}
          </p>
          <p class="m-0">
            {{ `${person.postalAddress.zip} ${person.postalAddress.city}` }}
          </p>
          <p class="m-0">
            {{ `${person.postalAddress.country ? person.postalAddress.country.label : ''}` }}
          </p>
        </div>
      </SummarizationItem>
      <SummarizationItem v-if="person.hasTemporaryResidence">
        <template v-slot:title>
          Temporary Address
        </template>
        <p class="m-0">
          {{ `${person.temporaryResidence.street} ${person.temporaryResidence.streetNumber}` }}
        </p>
        <p class="m-0">
          {{ `${person.temporaryResidence.zip} ${person.temporaryResidence.city}` }}
        </p>
        <p class="m-0">
          {{ `${person.temporaryResidence.country ? person.temporaryResidence.country.label : ''}` }}
        </p>
      </SummarizationItem>
    </SummarizationCard>

    <SummarizationCard title='Health Insurance Card Delivery'>
      <SummarizationItem>
        <template v-slot:title>
          Selected Delivery Method
        </template>
        <p v-if="model.cardDelivery.deliveryType === CardDeliveryTypeEnum.POST" class="m-0">
          Deliver the Health Insurance Card by Post
        </p>
        <p v-if="model.cardDelivery.deliveryType === CardDeliveryTypeEnum.CONTACT_PLACE" class="m-0">
          Collect Health Insurance Card at a Contact Point
        </p>
      </SummarizationItem>
      <div v-if="model.cardDelivery.deliveryType === CardDeliveryTypeEnum.POST">
        <SummarizationItem v-if="person.postalAddressSameAsAddress">
          <template v-slot:title>
            Mailing Address
          </template>
          <p class="m-0">
            {{ `${person.address.street} ${person.address.streetNumber}` }}
          </p>
          <p class="m-0">
            {{ `${person.address.zip} ${person.address.city}` }}
          </p>
          <p class="m-0">
            {{ `${person.address.country ? person.address.country.label : ''}` }}
          </p>
        </SummarizationItem>
        <SummarizationItem v-else-if="addressNotFilled(person.postalAddress) && person.hasTemporaryResidence">
          <template v-slot:title>
            Mailing Address
          </template>
          <p class="m-0">
            {{ `${person.temporaryResidence.street} ${person.temporaryResidence.streetNumber}` }}
          </p>
          <p class="m-0">
            {{ `${person.temporaryResidence.zip} ${person.temporaryResidence.city}` }}
          </p>
          <p class="m-0">
            {{ `${person.temporaryResidence.country ? person.temporaryResidence.country.label : ''}` }}
          </p>
        </SummarizationItem>
        <SummarizationItem v-else>
          <template v-slot:title>
            Mailing Address
          </template>
          <p class="m-0">
            {{ `${person.postalAddress.street} ${person.postalAddress.streetNumber}` }}
          </p>
          <p class="m-0">
            {{ `${person.postalAddress.zip} ${person.postalAddress.city}` }}
          </p>
          <p class="m-0">
            {{ `${person.postalAddress.country ? person.postalAddress.country.label : ''}` }}
          </p>
        </SummarizationItem>
      </div>
      <div v-if="model.cardDelivery.deliveryType === CardDeliveryTypeEnum.CONTACT_PLACE">
        <SummarizationItem>
          <template v-slot:title>
            Contact Point
          </template>
          <p class="m-0">
            {{ `${contactPlace.address}` }}
          </p>
          <p class="m-0">
            {{ `${contactPlace.zip} ${contactPlace.city}` }}
          </p>
          <p class="m-0">
            Slovak Republic
          </p>
        </SummarizationItem>
      </div>
    </SummarizationCard>
  </div>
</template>
<script>
import SummarizationCard from '@/components/SummarizationCard/SummarizationCard.vue';
import SummarizationItem from '@/components/SummarizationItem/SummarizationItem.vue';
import enums from '@/mixins/enums';
import { addressNotFilled } from '../utils/address';

export default {
  components: { SummarizationItem, SummarizationCard },
  mixins: [enums],
  props: {
    errors: { type: Array, required: true },
    model: { type: Object, required: true },
    person: { type: Object, required: true },
  },
  computed: {
    unemployedTypeEnum() {
      return this.enums.UnemployedTypeEnum;
    },
    InsuranceType() { return this.enums.InsuredPersonTypeEnum; },
    isChangeOfInsuranceCompany() {
      return this.person.insuredPersonType === this.InsuranceType.CHANGE_OF_INSURANCE_COMPANY_ADULT
        || this.person.insuredPersonType === this.InsuranceType.CHANGE_OF_INSURANCE_COMPANY_CHILD;
    },
    CardDeliveryTypeEnum() {
      return this.enums.CardDeliveryTypeEnum;
    },
    contactPlace() { return this.$store.state.contactPlaces?.find((place) => place.id === this.model.cardDelivery.contactPlace?.id); },
    isPassport() {
      const { EvidenceTypeEnum: enumeration } = this.enums;
      return this.person.evidenceType === enumeration.PASSPORT;
    },
    isID() {
      const { EvidenceTypeEnum: enumeration } = this.enums;
      return this.person.evidenceType === enumeration.ID;
    },
    isZiadost() {
      const { EvidenceTypeEnum: enumeration } = this.enums;
      return this.person.evidenceType === enumeration.ZIADOST;
    },
    isResidencePermit() {
      const { EvidenceTypeEnum: enumeration } = this.enums;
      return this.person.evidenceType === enumeration.RESIDENCE_PERMIT;
    },
  },
  methods: {
    addressNotFilled,
    formatDate(date) {
      return `${this.formatDateNumber(date.day)}.${this.formatDateNumber(date.month)}.${this.formatDateNumber(date.year)}`;
    },
    formatDateNumber(number) {
      if (number) {
        return number.toString().padStart(2, '0');
      }
      return '';
    },
  },
};
</script>
